import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Event } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { uniq, filter, find } from 'lodash';
import { classNames, eventDateRange, formatDate, formatDateString } from '@shapeable/utils';
import { EventSessionTabs, SessionList, useEntity } from '@shapeable/ui';
const cls = classNames('event-sessions-layout');

// -------- Types -------->

export type EventSessionsLayoutProps = Classable & HasChildren & { 
  entity?: Event;
};

export const EventSessionsLayoutDefaultProps: Omit<EventSessionsLayoutProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
   font-size: ${theme.FONT_SIZE(14)};
  `,
});


const TabsStyles = breakpoints({
  base: css`
    position: relative;
    width: 100%;
    padding-top: ${theme.UNIT(2)};
    padding-bottom: ${theme.UNIT(6)};
    overflow: hidden;
  `,
});


const AgendaStyles = breakpoints({
  base: css`
  `,
});

const SessionsStyles = breakpoints({
  base: css`
    padding-bottom: ${theme.UNIT(10)};
    width: 100%;
   
  

    .shp--session-layout {
      h3, h2 {
        margin: 0;
      }
    }

    .shp--header-divider__start,
    .shp--header-divider__end {
      ${theme.H_DOT_BG('line', 2, 6)};
    }

    h2.shp--header-divider {
      margin-top: ${theme.UNIT(4)};
    }
  `,
});



// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
  Tabs: styled(EventSessionTabs)`${TabsStyles}`,

  Agenda: styled.div`${AgendaStyles}`,
  Sessions: styled(SessionList)`${SessionsStyles}`,

};

export const EventSessionsLayout: React.FC<EventSessionsLayoutProps> = (props) => {
  const { className, children } = props;
  const entity = useEntity(props.entity);
  
  const { startDate, endDate } = entity;

  const sessions = filter(entity.sessions || [], session => !!session.startDate);

  const days = uniq(sessions.map(session => formatDateString(session.startDate, 'YYYY-MM-DD')));

  const today = formatDate(new Date(), 'YYYY-MM-DD');
  const defaultActiveDay = find(days, day => day === today) || (days.length && days[0]);

  const [ activeDay, setActiveDay ] = React.useState<string>(defaultActiveDay);

  const activeSessions = filter(sessions, session => (formatDateString(session.startDate, 'YYYY-MM-DD') === activeDay));
  const subtitle = eventDateRange(startDate, endDate);
  const tabOnClick = (day: string) => {
    setActiveDay(day); 
  };

  return (
    <My.Container>
      <My.Tabs
        entity={entity} 
        activeDay={activeDay}
        lineWidth={1}
        lineVariant="solid"
        onDateChange={tabOnClick}
      />

      <My.Sessions 
        groupByTimeOfDay 
        items={activeSessions} 
        sessionLayoutProps={{
          showCardStyles: true,
          lineColorPaths: ['value', 'darkValue'],
        }}
        />
    </My.Container>
  )
};

EventSessionsLayout.defaultProps = EventSessionsLayoutDefaultProps;